import type { PropsResponse } from './types';

import { apiClient } from '~shared/api/createApiClient';

export const getProps = (pharmacyId: string): Promise<PropsResponse> => {
  return apiClient.get<PropsResponse>('/api/props', { pharmacyId });
};
